/* eslint-disable eqeqeq */
import { Button } from "antd-mobile-v5";
import styled from "styled-components";

const FasterWrapper = styled.div`
  padding: 28px;
  padding-bottom:17px;
  text-align: center;
  background:#fff;
  .number {
    font-size: 20px;
    color: #070707;
    margin-bottom: 10px;
  }
  .center {
    padding: 4px 5px;
    width: 57px;
    margin: auto;
    border-radius: 2px;
    border: 1px solid #979797;
    opacity: 0.3;
    margin-bottom: 22px;
  }
  .btn {
    border-radius: 20px;
    width: 255px;
  }
`;
const Faster = () => {
  return (
    <FasterWrapper>
      <div className="number">152****8125</div>
      <div className="center">中国移动</div>
      <Button
        color="primary"
        className="btn"
        onClick={() => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          window.postMessage(`15241238125`);
        }}
      >
        {" "}
        一键注册
      </Button>
    </FasterWrapper>
  );
};
export default Faster;
